(async function(algolia) {
  'use strict';
  const insightsClient = window[window.AlgoliaAnalyticsObject];

  const index_suffix = await algolia.config.index_suffix;

  const enabled = algolia.config.analytics_enabled;
  if (!enabled || !insightsClient) return;

  // useCookie parameter set up
  const userTokenAdminSetting = algolia.config.usertoken_with_cookies === 'enabled';
  let useCookie = true;

  if(userTokenAdminSetting) {
    window.Shopify.loadFeatures(
      [
        {
          name: 'consent-tracking-api',
          version: '0.1',
        },
      ],
      error => {
        if (error) {
          console.error("Customer Privacy API Error", error);
        }
        const userCanBeTracked = window.Shopify.customerPrivacy ? window.Shopify.customerPrivacy.userCanBeTracked() : false;
        useCookie = userTokenAdminSetting && userCanBeTracked;

        // FP edit
        // insightsClient('init', {useCookie, partial: true});
        insightsClient('init', {appId: algolia.config.app_id, apiKey: algolia.config.search_api_key, useCookie, partial: true});
        // end FP edit
      },
    );
  } else {
    // FP edit
    // insightsClient('init', {useCookie: useCookie, partial: true});
    insightsClient('init', {appId: algolia.config.app_id, apiKey: algolia.config.search_api_key, useCookie, partial: true});
    // end FP edit
  }

  // Retrieving userToken
  console.log(insightsClient, "insightsClient above algolia token");
    let userToken;
    const foundAlgoliaToken = localStorage.getItem('algolia_usertoken');
    if(!foundAlgoliaToken){
      insightsClient('getUserToken', null, (err, newUserToken) => {
        if (err) {
          console.error(err);
          return;
        }
        userToken = newUserToken;
        localStorage.setItem("algolia_usertoken", userToken);
        return userToken;
      });

      if(foundAlgoliaToken == undefined){
        let algoliaUserToken = window.AlgoliaAnalytics.default._userToken;
        localStorage.setItem('algolia_usertoken', algoliaUserToken);
      }
    }
  // Local storage logic for conversion events
  const localStorageKey = 'algolia_analytics_clicked_objects';

  /**
   * Saves details in local storage for conversion tracking
   */
  algolia.saveForConversionTracking = function (data, localStorageKey) {
    /**
     * We're using a try, catch here to handle any possible exceptions
     * resulting from local storage or JSON parsing.
     */
    try {
      // Get any data previously stored
      const previousClickItemsString = localStorage.getItem(localStorageKey) || '[]';
      const previousClickItems = JSON.parse(previousClickItemsString);
      var conversionData = data;
      conversionData.eventName = 'conversion';
      // Removing the `positions` property
      delete conversionData.positions;

      // Add the current products data to local storage
      previousClickItems.push(data)
      localStorage.setItem(localStorageKey, JSON.stringify(previousClickItems));
    } catch (error) {
      console.error(error);
      // No need to do anything in this scenario
    }
  };

  /**
   * Try to get the details from local storage for conversion tracking.
   * We're using a try...catch here to handle any possible exceptions resulting
   * from local storage or JSON parsing.
   */
  function trackConversion(localStorageKey) {
    
    try {
      // Get any previously stored data.
      const previousClickItemsString = localStorage.getItem(localStorageKey);

      // If data was found, send a conversion event for those products.
      
      if (!!previousClickItemsString) {
        const previousClickItems = JSON.parse(previousClickItemsString);
        previousClickItems.forEach((data) => {
          data = {...data, userToken};
          console.log(insightsClient, "insights client");
          insightsClient('convertedObjectIDsAfterSearch', data)
        })
      }
    } catch (error) {
      console.error(error);
      // No need to do anything in this scenario.
    }

    // Try to remove the items from local storage.
    try {
      localStorage.removeItem(localStorageKey)
    } catch (error) {
      // No need to do anything in this scenario.
    }
  }

  /**
   *Track a conversion event when clicking the 'add to cart' button.
   *Change the query selector to be the correct one for your theme.
   */
  const addToCartBtn = document.querySelector('#AddToCart-product-template');
  const StickyaddToCartBtn = document.querySelector('.sticky_add_cta_button');
  if (addToCartBtn) {
    addToCartBtn.addEventListener('click', function (e) {
      console.log("track conversion for pdp atc");
      trackConversion(localStorageKey)
    })
  }
  if (StickyaddToCartBtn) {
  	StickyaddToCartBtn.addEventListener('click', function (e) {
      console.log("track conversion for sticky pdp atc");
  		trackConversion(localStorageKey);
  	});
  }
  document.addEventListener('addTrack', function() {
     console.log("track conversion for quick add");
    trackConversion(localStorageKey);
  });
})(window.algoliaShopify);
